import emit from "../../../common/events";
import { WishList } from '../interfaces/wish-list-items.interface';
import { mapWishListToWishListAnalyticsObject } from "../mapping/wish-list-analytics-mapping";
import { downloadOptionToAnalyticsLabel } from "./wish-list.util";

export class WishListOptionsAnalytics {
    /**
     * Event to track when the dropdown was toggled.
     *
     * @param identifier
     * @param element
     * @param expanded
     */
    dropdownToggle(identifier: string, element: Element, expanded: boolean): void {
      emit({
        element: element,
        name: 'click',
        detail: {
          eventName: `${identifier}-option-dropdown`,
          action: expanded ? 'opening' : 'closing',
          label: `Wish List Dropdown ${expanded ? 'Opening' : 'Closing'}`,
          comp: 'dropdown',
        }
      });
    }
  
    /**
     * Event to trigger the event listener wish-list-option-selection
     *
     * @param identifier
     * @param element
     * @param option
     * @param wishList
     * @param id
     */
    optionSelection(identifier: string, element: Element, option: string, wishList?: WishList, id?: string): void {
      emit({
        element: element,
        name: 'click',
        detail: {
          wishList: wishList!,
          eventName: `${identifier}-option-selection`,
          option: option,
          id,
        },
        dataLayer: false,
      });
    }

    /**
     * Event to track which dropdown option is selected.
     *
     * @param identifier
     * @param element
     * @param option
     * @param wishList
     * @param id
     */
    optionSelectionEvent(identifier: string, element: Element, option: string, wishList?: WishList, id?: string): void {
      emit({
        element: element,
        name: 'click',
        detail: {
          wishList: mapWishListToWishListAnalyticsObject(wishList!),
          eventName: `${identifier}-option-selected`,
          option: option,
          buttonId: id,
          label: `${downloadOptionToAnalyticsLabel(option)} Option Selected`,
          comp: 'wish-list',
        }
      });
    }

    /**
     * Event to track which wishlist option is clicked.
     *
     * @param wishListName
     * @param element
     * @param option
     * @param wishList
     * @param id
     */
    wishListSelection(element: Element, wishList: WishList): void {
      emit({
        element: element,
        name: 'click',
        detail: {
          wishList: mapWishListToWishListAnalyticsObject(wishList),
          eventName: `${wishList.name}-option-selection`,
          wishListId: wishList.wishlist_id,
          label: wishList.name,
          comp: 'wish-list',
        },
      });
    }

    /**
     * Event to track which wishlist option is clicked.
     *
     * @param button
     * @param element
     * @param option
     * @param wishList
     * @param id
     */
    offCanvasOptionSelection(button: string, element: Element, wishList: WishList, id: number, option: string): void {
      emit({
        element: element,
        name: 'click',
        detail: {
          wishList: mapWishListToWishListAnalyticsObject(wishList),
          eventName: `offcanvas-${button}-clicked`,
          wishListId: id,
          option: option,
          label: wishList.name,
          comp: 'dropdown',
        }
      });
    }
  }